import React, { useState, useEffect, useRef, forwardRef } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { addFieldValue, inspectionSelector } from "../../redux/inspectionSlice";
import { addLookup } from "../../redux/lookupSlice";
import { surveySelector } from "../../redux/surveySlice";
import { api } from "../../services/api-service";
import Selectable from "../Form/Selectable";
import { Icon } from "@iconify/react";
const AddInfo = forwardRef((props, ref) => {
  const structure = useRef(null);
  const roof = useRef(null);
  const me = useRef(null);
  const external = useRef(null);
  const nia = useRef(null);

  const dispatch = useDispatch();
  const survey = useSelector(surveySelector);
  const inspection = useSelector(inspectionSelector);
  const [isActive, setIsActive] = useState("structure");
  const [template, setTemplate] = useState();
  const [fields, setFields] = useState([]);
  const [erase, setErase] = useState(false);

  const styles = {
    border: "0.0625rem solid #9c9c9c",
    borderRadius: "0.25rem",
  };

  useEffect(() => {
    const topMenu = document.querySelector(".modalDrawer .modal-body");
    topMenu.addEventListener("scroll", () => {
      topMenu.classList.add("sticky");
    });
    if (inspection.sketch?.["paths"]?.length > 0) {
      ref.current.loadPaths(inspection["sketch"]["paths"]);
    }
  }, []);

  useEffect(() => {
    getFields();
  }, []);

  const getTemplate = async (id) => {
    const response = await api.get(`get-template/${id}`);
    if (response && response.ok) {
      setTemplate(response.data.data);
    }
  };

  useEffect(() => {
    if (template && template.fields?.length > 0) {
      setFields(
        fields.filter(
          (field) =>
            field.isRequired ||
            template.fields.find((fld) => fld.id === field.id)?.isIncluded
        )
      );
    }
  }, [template]);

  const getFields = async () => {
    const response = await api.get("get-fields?type=");
    if (response && response.ok) {
      setFields(
        response.data.data.map((field) => {
          return {
            ...field,
            handleChange: (val) => handleChange(field.name, val),
            options:
              field.type === "select" ? getLookup(field.name) : undefined,
          };
        })
      );
      if (survey.templateId) {
        getTemplate(survey.templateId);
      }
    }
  };

  const getLookup = async (field) => {
    const response = await api.get(`lookup?type=${field}`);
    if (response && response.ok) {
      const data = response.data.data.map((data) => {
        return { ...data, label: data.id, value: data.id };
      });
      dispatch(addLookup({ type: field, value: data }));
      return data;
    }
  };

  const handleChange = (name, value) => {
    const fields = name.split(":");
    dispatch(addFieldValue({ field: fields[0], subfield: fields[1], value }));
  };

  const handleNIAChange = async (e) => {
    ref.current.exportImage("png").then(async (data) => {
      dispatch(
        addFieldValue({ field: "sketch", subfield: "url", value: data })
      );
    });
    ref.current.exportPaths().then((data) => {
      dispatch(
        addFieldValue({ field: "sketch", subfield: "paths", value: data })
      );
    });
  };

  const handleClick = (e, active) => {
    e.current?.scrollIntoView({ behavior: "smooth" });
    setIsActive(active);
  };

  return (
    <>
      <div className="pt-3">
        <Row>
          <Col xs="6" className="mb-4">
            <div className="formGroup">
              <label>Code</label>
              <input
                type="text"
                className="form-control"
                value={inspection["code"]}
                onChange={(e) =>
                  dispatch(
                    addFieldValue({ field: "code", value: e.target.value })
                  )
                }
              />
            </div>
          </Col>
          <Col xs="6" className="mb-4">
            <div className="formGroup">
              <label>Age of build</label>
              <input
                type="text"
                value={inspection["ageOfBuild"]}
                onChange={(e) =>
                  dispatch(
                    addFieldValue({
                      field: "ageOfBuild",
                      value: e.target.value,
                    })
                  )
                }
                className="form-control"
              />
            </div>
          </Col>
          <Col lg="12" className="mb-4">
            <div className="fieldset">
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control
                  value={inspection["description"]}
                  as="textarea"
                  placeholder="Placeholder"
                  onChange={(e) =>
                    dispatch(
                      addFieldValue({
                        field: "description",
                        value: e.target.value,
                      })
                    )
                  }
                  style={{ height: "139px" }}
                />
              </Form.Group>
            </div>
          </Col>
        </Row>
      </div>
      <div className="table-responsive mb-lg-0 mb-3 navLinks p-0 m-0">
        <ul className="navLinks">
          <li>
            <Link
              to="#"
              className={isActive === "structure" ? "active" : ""}
              onClick={() => handleClick(structure, "structure")}
            >
              Structure
            </Link>
          </li>
          <li>
            <Link
              to="#"
              className={isActive === "roof" ? "active" : ""}
              onClick={() => handleClick(roof, "roof")}
            >
              Roof
            </Link>
          </li>
          <li>
            <Link
              to="#"
              className={isActive === "me" ? "active" : ""}
              onClick={() => handleClick(me, "me")}
            >
              M&E
            </Link>
          </li>
          <li>
            <Link
              to="#"
              className={isActive === "ext" ? "active" : ""}
              onClick={() => handleClick(external, "ext")}
            >
              External
            </Link>
          </li>
          <li>
            <Link
              to="#"
              className={isActive === "nia" ? "active" : ""}
              onClick={() => handleClick(external, "nia")}
            >
              NIA/GIA/GEA
            </Link>
          </li>
        </ul>
      </div>
      <div
        className={
          isActive === "structure" ? "contentForm active" : "contentForm"
        }
        ref={structure}
      >
        {fields.filter((field) => field.name.includes("structure")).length >
          0 && <h4>Structure</h4>}
        {fields.map(
          (field) =>
            field.name.includes("structure") && (
              <Row key={field.id} className="align-items-center mb-1">
                <Col xs="6">
                  <label className="mb-lg-0">{field.title}</label>
                </Col>
                <Col xs="6">
                  <div className="selectNoBorder">
                    <Selectable
                      value={
                        inspection[field.name.split(":")[0]][
                          field.name.split(":")[1]
                        ]
                      }
                      options={field.options}
                      onChange={field.handleChange}
                    />
                  </div>
                </Col>
              </Row>
            )
        )}
      </div>
      <div
        className={isActive === "roof" ? "contentForm active" : "contentForm"}
        ref={roof}
      >
        {fields.filter((field) => field.name.includes("roof")).length > 0 && (
          <h4>Roof</h4>
        )}
        {fields.map(
          (field) =>
            field.name.includes("roof") && (
              <Row key={field.id} className="align-items-center mb-1">
                <Col xs="6">
                  <label className="mb-lg-0">{field.title}</label>
                </Col>
                <Col xs="6">
                  <div className="selectNoBorder">
                    <Selectable
                      value={
                        inspection[field.name.split(":")[0]][
                          field.name.split(":")[1]
                        ]
                      }
                      options={field.options}
                      onChange={field.handleChange}
                    />
                  </div>
                </Col>
              </Row>
            )
        )}
      </div>
      <div
        className={isActive === "me" ? "contentForm active" : "contentForm"}
        ref={me}
      >
        {fields.filter((field) => field.name.includes("mAndE")).length > 0 && (
          <h4>M&E</h4>
        )}

        {fields.map(
          (field) =>
            field.name.includes("mAndE") && (
              <Row key={field.id} className="align-items-center mb-1">
                <Col xs="6">
                  <label className="mb-lg-0">{field.title}</label>
                </Col>
                <Col xs="6">
                  <div className="selectNoBorder">
                    <Selectable
                      value={
                        inspection[field.name.split(":")[0]][
                          field.name.split(":")[1]
                        ]
                      }
                      options={field.options}
                      onChange={field.handleChange}
                    />
                  </div>
                </Col>
              </Row>
            )
        )}
      </div>
      <div
        className={isActive === "ext" ? "contentForm active" : "contentForm"}
        ref={external}
      >
        {fields.filter((field) => field.name.includes("external")).length >
          0 && <h4>Externals</h4>}
        {fields.map(
          (field) =>
            field.name.includes("external") && (
              <Row key={field.id} className="align-items-center mb-1">
                <Col xs="6">
                  <label className="mb-lg-0">{field.title}</label>
                </Col>
                <Col xs="6">
                  <div className="selectNoBorder">
                    <Selectable
                      value={
                        inspection[field.name.split(":")[0]][
                          field.name.split(":")[1]
                        ]
                      }
                      options={field.options}
                      onChange={field.handleChange}
                    />
                  </div>
                </Col>
              </Row>
            )
        )}
      </div>
      <div
        className={isActive === "nia" ? "contentForm active" : "contentForm"}
        ref={external}
      >
        <h4>NIA/GIA/GEA (Measurements)</h4>
        <ul className="actionTemplate d-flex align-items-center">
          <li>
            <Button
              variant="ctaIcon"
              onClick={() => {
                ref.current?.eraseMode(!erase);
                setErase(!erase);
              }}
            >
              <Icon icon="ph:eraser" />
            </Button>
          </li>
          <li>
            <Button variant="ctaIcon" onClick={() => ref.current?.undo()}>
              <Icon icon="lucide:undo" />
            </Button>
          </li>
          <li>
            <Button variant="ctaIcon" onClick={() => ref.current?.redo()}>
              <Icon icon="lucide:redo" />
            </Button>
          </li>
          <li>
            <Button
              variant="ctaIcon"
              onClick={() => ref.current?.clearCanvas()}
            >
              <Icon icon="ic:round-clear" />
            </Button>
          </li>
          <li className="ms-auto">
            <Button
              variant="ctaIcon"
              onClick={props.onToggleSketchSize}
              title={
                props.isSketchExpanded
                  ? "Restore drawing size"
                  : "Expand drawing area"
              }
              aria-label={
                props.isSketchExpanded
                  ? "Restore drawing size"
                  : "Expand drawing area"
              }
              aria-pressed={props.isSketchExpanded}
            >
              <Icon
                icon={
                  props.isSketchExpanded
                    ? "mdi:fullscreen-exit"
                    : "mdi:fullscreen"
                }
              />
            </Button>
          </li>
        </ul>
        <Row className="align-items-center">
          <Col lg="12">
            <div className="fieldset inspection-sketch-wrapper">
              <ReactSketchCanvas
                style={styles}
                width="600"
                className="inspection-sketch-canvas"
                ref={ref}
                onChange={(e) => {
                  handleNIAChange(e);
                }}
                height="400"
                strokeWidth={4}
                strokeColor="red"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
});

export default AddInfo;
